const formValuesToCancalItem = (item: any) => ({
  id: item.id,
  reason: item.reason,
  reasonComment: item.reasonComment,
  dealId: item.dealId,
  description: item.description
});

export default formValuesToCancalItem;
